import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import {AcceptChangeSchema, AcceptData, AcceptDataBackend} from "./models-service";

const route_ns = `accept_log`;

class AcceptLogService {

    public data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);
    public filters_changed: boolean = false;
    public data_loaded: boolean = false;

  constructor() {
    //
  }


  empty() {

  }

}

export default new AcceptLogService();
